import React, { Fragment, useEffect, useState } from "react";
import "./Dashboard.scss";
import { Card, Tooltip } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getClusterData,
  getConnectionStatus,
  getJobList,
  getApiUserRoles,
  getLiveJobList,
  getLogLevel,
  getLogSnippet,
  updateLogLevel,
} from "../../Utils/actions";
import JobTable from "./JobTable";
import { REDIRECT } from "../../Utils/constants/action-types";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import ChartDisplay from "./ChartDisplay";
import "../User/VUser.scss";
import { abbrNum, loadingOff, loadingOn } from "../../Utils/utils";
import LogViewModal from "./LogViewModal";
import {
  activeWells,
  dataQualityTotalRecord,
  yhAddress,
  yhPort,
} from "../../Pages/YH/DqDummy";
import DataQualityGraph from "../../Pages/YH/DataQualityGraph";
import { Cell, LabelList, Pie, PieChart, ResponsiveContainer } from "recharts";
import DataQuality from "./DataQuality";

const Dashboard = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isAuthenticated, groups } = useSelector((state) => state.auth);
  const {
    jobList,
    logSnippet,
    connectionStatus,
    version,
    clusterData,
    liveJobList,
  } = useSelector((state) => state.data);
  const [logLevel, setLogLevel] = useState("");
  const [firstTimeRender, setfirstTimeRender] = useState(false);
  const [logShow, setLogShow] = useState(false);
  const [activeRigId, setActiveRigId] = useState("");
  const [DQGraph, setDQGraph] = useState(false);

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(
    sessionStorage.getItem("activePageSize")
      ? sessionStorage.getItem("activePageSize")
      : 10
  );
  const [pageIndexFinish, setPageIndexFinish] = useState(0);
  const [pageSizeFinish, setPageSizeFinish] = useState(
    sessionStorage.getItem("finishPageSize")
      ? sessionStorage.getItem("finishPageSize")
      : 10
  );

  // const [pagination, setPagination] = useState({
  //   pageIndex: 0,
  //   pageSize: 10,
  // });
  // const [finishJobPagination, setFinishJobPagination] = useState({
  //   pageIndex: 0,
  //   pageSize: 10,
  // });

  useEffect(() => {
    // if (sessionStorage.getItem("activeTab") != null) {
    sessionStorage.getItem("activeTab") == 0
      ? dispatch(getLiveJobList("active", pageSize, pageIndex))
      : dispatch(getLiveJobList("finish", pageSizeFinish, pageIndexFinish));
    // }
    // dispatch(getLiveJobList("active", { pageSize: pagination.pageSize, pageNumber: pagination.pageIndex + 1 }));
  }, [pageSizeFinish, pageIndexFinish, pageSize, pageIndex]);

  // useEffect(() => {
  //   dispatch(getLiveJobList("finish", { pageSize: finishJobPagination.pageSize, pageNumber: finishJobPagination.pageIndex + 1 }));
  // }, [finishJobPagination])

  useEffect(() => {
    dispatch({
      type: REDIRECT,
      payload: false,
    });
  }, [dispatch]);

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(getApiUserRoles(sessionStorage.getItem("username")));
    }
  }, []);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login");
    }
    // eslint-disable-next-line
  }, [isAuthenticated, location.pathname]);

  useEffect(() => {
    if (isAuthenticated && !firstTimeRender) {
      dispatch(loadingOn());
      // dispatch(getJobList());
      if (sessionStorage.getItem("activeTab") != null) {
        sessionStorage.getItem("activeTab") == 0
          ? dispatch(getLiveJobList("active", pageSize, pageIndex))
          : dispatch(getLiveJobList("finish", pageSizeFinish, pageIndexFinish));
      }
      setfirstTimeRender(true);
      // dispatch(getClusterData());
      // dispatch(getLogSnippet(100, false));
      // dispatch(getLogLevel());
    }
    const interval = setInterval(() => {
      if (isAuthenticated) {
        dispatch(loadingOn());
        // dispatch(getConnectionStatus());
        // dispatch(getJobList());
        // dispatch(getClusterData());
        // dispatch(getLogSnippet(100, false));
        // dispatch(getLogLevel());
      }
    }, 300000);

    const interval2 = setInterval(() => {
      if (isAuthenticated) {
        if (sessionStorage.getItem("activeTab") != null) {
          sessionStorage.getItem("activeTab") == 0
            ? dispatch(getLiveJobList("active", pageSize, pageIndex))
            : dispatch(
                getLiveJobList("finish", pageSizeFinish, pageIndexFinish)
              );
        }
        // dispatch(getLiveJobList("active", { pageSize: pagination.pageSize, pageNumber: pagination.pageIndex + 1 }));
        // dispatch(getLiveJobList("finish", { pageSize: finishJobPagination.pageSize, pageNumber: finishJobPagination.pageIndex + 1 }));
      }
    }, 300000);

    return () => {
      clearInterval(interval);
      clearInterval(interval2);
    };
  }, [
    isAuthenticated,
    firstTimeRender,
    pageSize,
    pageIndex,
    pageSizeFinish,
    pageIndexFinish,
    dispatch,
  ]);

  const handleRefresh = () => {
    dispatch(getLogSnippet(100));
  };

  // useEffect(() => {
  //     if (dataQualityTotalRecord) {
  //         setJson(dataQualityTotalRecord);
  //     }
  // }, [dataQualityTotalRecord]);

  // const handleLogClose = () => setLogShow(false);

  // const handleLogShow = () => setLogShow(true);

  const handleLogLevel = (e) => {
    dispatch(updateLogLevel(e.target.value));
    dispatch(getLogSnippet(100));
    setLogLevel(e.target.value);
  };

  const [logs, setLogs] = useState();
  const [well, setWell] = useState();
  const [rigsId, setRigsId] = useState();
  const [allJobsData, setAllJobsData] = useState();
  // const [logs, setLogs] = useState(liveJobList[0]?.log);
  // const [well, setWell] = useState(liveJobList[0]?.assetId);
  // const [rigsId, setRigsId] = useState(liveJobList[0]?.rigId);
  // const [allJobsData, setAllJobsData] = useState(liveJobList[0]);
  const [firstRowData, setFirstRowData] = useState(null);

  // eslint-disable-next-line
  const cmpntGroup = JSON.parse(
    sessionStorage.getItem("cmpntGroup")
      ? sessionStorage.getItem("cmpntGroup")
      : "{}"
  );

  const [isFullScreen, setIsFullScreen] = useState(false);

  // Function to toggle full screen mode
  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  return (
    <Fragment>
      <Card
        className={"w-100 dashboard-card"}
        style={{
          backgroundColor: "#333333",
          padding: "15px",
          overflow: "auto",
          height: "89vh",
          border: "none",
        }}
      >
        <Card.Body
          className={"dashboard_content"}
          style={{
            overflow: "hidden",
            padding: "0px",
            backgroundColor: "#333333",
          }}
        >
          <div
            className={
              "d-flex col-md-12 dashboard_sub_content justify-content-between p-0"
            }
          >
            {cmpntGroup["jobs"]?.Read && !isFullScreen && (
              <div
                className={"col-md-8 "}
                style={{ backgroundColor: "#242424", borderRadius: "5px" }}
              >
                <JobTable
                  setPageSizeFinish={setPageSizeFinish}
                  setPageIndexFinish={setPageIndexFinish}
                  setPageSize={setPageSize}
                  setPageIndex={setPageIndex}
                  pageSizeFinish={pageSizeFinish}
                  pageIndexFinish={pageIndexFinish}
                  pageSize={pageSize}
                  pageIndex={pageIndex}
                  setLogs={setLogs}
                  setWell={setWell}
                  setRigsId={setRigsId}
                  setAllJobsData={setAllJobsData}
                />
              </div>
            )}
            <div
              className={isFullScreen ? "col-md-12" : "col-md-4"}
              style={{
                backgroundColor: "#242424",
                borderRadius: "5px",
                marginLeft: isFullScreen ? "0px" : "15px",
              }}
            >
              <DataQuality
                isFullScreen={isFullScreen}
                toggleFullScreen={toggleFullScreen}
                selectedRig={activeRigId}
                setDQGraph={setDQGraph}
                activeWell={activeWells?.[activeRigId]?.["active_well_id"]}
                yhAddress={yhAddress}
                yhPort={yhPort}
                logs={logs}
                well={well}
                rigsId={rigsId}
                allJobsData={allJobsData}
              />
            </div>
          </div>
        </Card.Body>
      </Card>
    </Fragment>
  );
};

export default Dashboard;
